import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { ApiKey } from '../../../../../../../../../typings/ApiKey.interface';
import { ApiKeyScopeFormValues, ApiKeyScopesFields, getInitialScopeValues, scopesFromScopeValues } from '../../../../../common/ApiKeys/ApiKeyScopesFields';
import SelectInput from '../../../../../common/Form/Fields/SelectInput';
import TextInput from '../../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Modal from '../../../../../common/Modal';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { DashboardContext } from '../../../DashboardContext';
interface FormValues extends ApiKeyScopeFormValues {
  label: string;
  team_id: string;
}
interface Props {
  onApiKeyCreated: (api_key: ApiKey) => void;
}
const AddProjectApiKeyModal: React.FC<Props> = t0 => {
  const $ = _c(24);
  const {
    onApiKeyCreated
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    organization,
    teams
  } = useContext(DashboardContext);
  const history = useHistory();
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  organization?.id;
  let t1;
  if ($[0] !== organization?.id || $[1] !== teams) {
    let t2;
    if ($[3] !== organization?.id) {
      t2 = team => team.organization_id === organization?.id;
      $[3] = organization?.id;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = (teams ?? []).filter(t2).map(_temp);
    $[0] = organization?.id;
    $[1] = teams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const project_options = t1;
  let t2;
  if ($[5] !== project_options) {
    t2 = team_id => project_options.filter(project => project.value === team_id).map(_temp2);
    $[5] = project_options;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const projectTypes = t2;
  let t3;
  if ($[7] !== history || $[8] !== location.search) {
    t3 = () => {
      history.push({
        pathname: "/settings/organization/api-keys",
        search: location.search,
        state: {
          scroll: false
        }
      });
    };
    $[7] = history;
    $[8] = location.search;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onClose = t3;
  const validate = _temp3;
  let t4;
  if ($[10] !== HookdeckAPI || $[11] !== addToast || $[12] !== onApiKeyCreated || $[13] !== onClose || $[14] !== projectTypes) {
    t4 = async values_0 => {
      ;
      try {
        const api_key = await HookdeckAPI.organizations.createApiKey({
          label: values_0.label.trim(),
          type: "project",
          team_id: values_0.team_id,
          scopes: scopesFromScopeValues("project", values_0, projectTypes(values_0.team_id))
        });
        onApiKeyCreated(api_key);
        addToast("success", "API key created");
        onClose();
      } catch (t5) {
        const err = t5;
        addToast("error", err.message);
      }
    };
    $[10] = HookdeckAPI;
    $[11] = addToast;
    $[12] = onApiKeyCreated;
    $[13] = onClose;
    $[14] = projectTypes;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const onSubmit = t4;
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      label: "",
      team_id: "",
      ...getInitialScopeValues("project")
    };
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== onClose || $[18] !== projectTypes || $[19] !== project_options) {
    t6 = props => <form onSubmit={props.handleSubmit}><Modal title="Create Project API Key" submit_label="Create Project API Key" cancel_label="Cancel" hide_close={true} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose} is_submitting={props.isSubmitting} submit_disabled={!props.isValid}><Div flex={{
          direction: "column"
        }}><TextInput name="label" label="Name" placeholder="e.g. CI pipeline" auto_complete="off" focus={true} /><SelectInput block={true} name="team_id" label="Project" placeholder="Select a project" required={true} options={project_options} /><ApiKeyScopesFields tier="project" project_types={projectTypes(props.values.team_id)} /></Div></Modal></form>;
    $[17] = onClose;
    $[18] = projectTypes;
    $[19] = project_options;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== onSubmit || $[22] !== t6) {
    t7 = <Formik initialValues={t5} onSubmit={onSubmit} validate={validate} validateOnMount={true}>{t6}</Formik>;
    $[21] = onSubmit;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default AddProjectApiKeyModal;
function _temp(team_0) {
  return {
    label: team_0.name,
    value: team_0.id,
    type: team_0.type
  };
}
function _temp2(t0) {
  const {
    type
  } = t0;
  return type;
}
function _temp3(values) {
  const errors = {};
  if (!values.label?.trim()) {
    errors.label = "Required";
  }
  if (!values.team_id) {
    errors.team_id = "Required";
  }
  return errors;
}